import i18n from "@/i18n";

export const STMT_TABLE_CONFIG = {
    pageSize: 10,
    pageRank: [10, 20, 30]
};

export const REPOSITORY_OPTIONS = [
    {
        label: i18n.t("statement.publicRepository"),
        value: 1
    },
    {
        label: i18n.t("statement.privateRepository"),
        value: 2
    }
];
